export default __webpack_public_path__ + "static/media/guiaAndroid4.756273ce.png";